import { AnimatePresence, motion, Variants } from 'framer-motion'

interface Props {
  rows?: number
  columns?: number
}

export const SpreadsheetLoader = ({ rows = 20, columns = 6 }: Props) => {
  const cellCount = rows * columns

  const container = {
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.01,
        delayChildren: 0.2,
      },
    },
  }

  const cell: Variants = {
    hidden: { opacity: 0 },
    show: (index: number) => ({
      opacity: [0, 1, 0],
      transition: {
        repeat: Infinity,
        repeatType: 'reverse',
        duration: 2,
        ease: 'easeInOut',
        delay: ((index % columns) + Math.floor(index / columns)) * 0.05,
      },
    }),
  }

  return (
    <section className="flex flex-col w-full h-full overflow-auto">
      <AnimatePresence>
        <motion.div
          className="w-full grid bg-cv-blue-100 border-bottom border-cv-blue-200"
          style={{
            // gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gridTemplateColumns: `minmax(0, 60px) repeat(${columns - 1}, minmax(0, 1fr))`,
          }}
          variants={container}
          animate="show"
        >
          {[...Array(cellCount)].map((_, i) => (
            <motion.div
              key={i}
              className={`flex items-center justify-center border-[.5px] border-cv-blue-200 ${
                i % columns === 0 ? 'first:max-w-[60px] !bg-cv-blue-100' : ''
              } ${
                i < columns
                  ? 'bg-cv-blue-100 h-14'
                  : Math.floor(i / columns) % 2 === 0
                    ? 'bg-cv-blue-100 h-9'
                    : 'bg-white h-9'
              }`}
              variants={cell}
              custom={i}
            />
          ))}
        </motion.div>
      </AnimatePresence>
    </section>
  )
}
